import React from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Create = () => {

    const { addData } = useEntityCrud('Branch/SetBranch');
    const navigate = useNavigate();

    const initialValues = {
        title: '',
        address: '',
        tel: '',
        holdingId: ''
    };

    const validationSchema = Yup.object({
        title: Yup.string()
            .required(),
        holdingId: Yup.string()
            .required(),
        address: Yup.string()
            .min(10, 'طول آدرس وارد شده کوتاه است')
            .required(),
        phone: Yup.string()
            .test('phone', 'شماره تلفن وارد شده معتبر نمی باشد', value => {
                return value && /^\d+$/.test(value.toString().replace('-', '')) && !value.startsWith('09') && value.length == 12;
            })
    });

    const onSubmit = (values) => {
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            title: values.title,
            address: values.address,
            phone: values.phone,
            holdingId: values.holdingId,
            logo: values.logo ? values.logo.split('base64,')[1] : '',
        };
        if(values.parentId)
            postedData.parentId = values.parentId;
        addData(postedData).then(({ data }) => {
            if (data.status) {
                toast.success('شرکت زیر مجموعه جدید با موفقیت ایجاد شد');
                return navigate('/branches');
            }
            else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/branches', { replace: true });
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ایجاد شرکت زیر مجموعه جدید</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik} />
            </div>
        </div>
    );
}

export default Create;